const si = {
    msgAppName: "FLIER",

    actionGetStart: "Začni",
    actionDetails: "Podrobnosti",
    actionLogin: "Prijavi se",
    actionRegister: "Prijavi se",
    actionLogout: "odjava",
    actionSend: "Pošlji",
    actionGoTest: "Pojdi na test",
    actionSeeCert: "Oglej si potrdilo",
    actionNextPill: "Pojdi na naslednjo lekcijo",
    actionNewThread: "Nova tema",
    actionBack: "Pojdi nazaj",
    actionComment: "Komentar",
    actionUpdate: "Posodobi",
    actionChangePass: "Zamenjaj geslo",
    actionAddAnnouncement: "Dodaj obvestilo",
    actionStartTest: "Začni test",
    actionSubmit: "Submit",
    actionClose: "Zapri",
    actionEdit: "Uredi",
    actionDelete: "Izbriši",
    actionShow: "Pokaži",
    actionNext: "Naprej",
    actionDone: "Končano",
    actionOpenResource: "Odprti vir",
    actionDownloadInfo: "Prenesi uporabniški prirpčnik",
    actionDownloadScript: "Prenesi skripto",
    actionDownloadPresentation:"Prenesi predstavitev",
    actionCourseCertificate: "Potrdilo o tečaju",
    actionRequestCode: "Zahtevaj kodo",

    msgWelcome: "Dobrodošli",
    msgBackToUnit: "Nazaj na učno enoto",
    msgExploreUnits: "Seznanite se s spletnim tečajem usposabljanja FLIER, ki je namenjen oblikovalcem krožnega pohištva",
    msgExploreUnitsText: "V okviru projekta FLIER smo razvili nov učni načrt in spletni tečaj (25 ur, 1 kreditna točka ECVET, EQF4) za oblikovalce krožnega pohištva. Naš cilj je pripraviti pohištveni sektor in njegove oblikovalce na nove izzive in priložnosti krožnega prehoda ter na novo evropsko okoljsko zakonodajo, ki bo veljala za ta sektor.<br/><br/>Oblikovalca krožnega pohištva opredeljujemo kot strokovnjaka, ki pri oblikovanju in proizvodnji pohištva uporablja načela trajnosti in krožnosti. Odgovoren je za omogočanje prehoda tradicionalnih postopkov proizvodnje pohištva na bolj trajnostne in krožne prakse.",
    msgLearningUnits: "Učne enote",
    msgLatestPills: "Priporočene lekcije",
    msgLatestPillsText: "Odkrijte lekcije, ki jih priporočajo naši evropski partnerji. ",

    msgPills: "Lekcije",
    msgPartners: "Partnerji",
    msgNextLearning: "Naslednji eučne enote",

    msgExamAlert: "Po zaključku vseh lekcij v učnih notah morajo učenci/študenjtje opraviti  <b>samoocenjevanje z več možnostmi</b> da pridobijo <b>certifikat  in digitalno značko.</b> Za uspešno opravljeno učno enoto je potreno najmanj <b> 75%</b>.",
    msgAssignment: "Naloga",
    msgForStudents: "PROJEKTNA NALOGA LU1-4",
    msgForTeachers: "NALOGA UČNE ENOTE%d",
    msgProgressionOptions: "Možnosti napredovanja",
    msgProgressionOptionsSubtitle: "Povezave do nekaterih dodatnih možnosti napredovanja:",
    msgCompetencesUnitTitle: "Po zaključku lekcij v učni enoti bi morali biti učenci sposobni:",

    msgCompetencesTitle: "Po zaključku te lekcije bi morali učenci znati:",
    msgTopics: "Teme",
    msgHowApply: "Primer dobre praksee",
    msgCaseStudy: "Študijski primer",
    msgInterview: "Intervju",
    msgResources: "Učni viri",
    msgResourcesSubtitle: "Povezave .",

    msgStartTestSubtitle: "**Po zaključku vseh lekcij v učni enoti**",

    msgWooLearningPlatform: "Izobraževalna platforma FLIER",
    msgWooLearningPlatformText: "V nadaljevanju so navedene spretnosti, znanja in kompetence (SKC), ki jih želimo s tem tečajem okrepiti pri oblikovalcih krožnega pohištva:</br></br><b>Spretnosti:</b> razumevanje načel krožnega gospodarstva, oblikovalske spretnosti in poznavanje trajnostnih materialov.</br></br><b>Znanje:</b> poznavanje trendov v pohištvenem sektorju, zakonodajnih in prostovoljnih instrumentov ter tveganj za zdravje in varnost pri delu.</br></br><b>Kompetence:</b> napovedovanje in načrtovanje scenarijev, vključevanje zainteresiranih strani in izvajanje pobud za krožno gospodarstvo.</br></br>Usposabljanje je priporočljivo za:",

    msgStudents: "Študentje",
    msgEducators: "Pedagogi",
    msgCompanies: "Ostali delavci / Brezposelni",
    msgProfessionals: "Oblikovalce",

    msgStudentsText: "Študenti poklicnega izobraževanja in usposabljanja ter študenti visokošolskih zavodov, ki študirajo oblikovanje pohištva in trajnost.",
    msgEducatorsText: "Ponudniki poklicnega izobraževanja in usposabljanja ter visokošolske ustanove na področju oblikovanja pohištva ali trajnosti.",
    msgCompaniesText: "Drugi delavci, ki so posredno vključeni v postopke oblikovanja. Tisti, ki iščejo priložnosti za razvoj posebnih poklicnih spretnosti in/ali odkrivanje novih poklicnih poti.",
    msgProfessionalsText: "Strokovnjaki iz pohištvene industrije, odgovorni za oblikovanje in razvoj izdelkov.",

    msgContact: "Vsebina",
    msgHome: "Domov",
    msgForum: "Forum",
    msgProfile: "Profil",

    msgAnnouncements: "Obvestila",
    msgAnnouncementsFinished: "Končne objave",

    msgThreads: "Teme",
    msgOpen: "Odpri",
    msgClose: "zapri",
    msgLeaveComment: "Pustite komentar",

    msgTeacherProfile: "Profil učitelja",
    msgUserProfile: "Uporabniški profil",
    msgUserInfo: "Informacije o uporabniku",

    msgRegisterText: "Registrirajte se in raziščite spletni tečaj usposabljanja FLIER.",

    msgName: "Ime in priimek",
    msgEmail: "e-pošta",
    msgCountry: "Država",
    msgAge: "Starost",
    msgGender: "Spol",
    msgOrganization: "Organizacija",

    msgForgetPass: "Ste pozabili geslo?",
    msgRecoveryPassword: "Obnovitev gesla",
    msgCode: "Koda",

    msgPassword: "Geslo",
    msgPassInfo: "Spremenite trenutno geslo",
    msgCurrentPass: "Trenutno geslo",
    msgNewPassword: "Novo geslo",

    msgNewAnnouncement: "Novo obvestilo",
    msgNewAnnouncementInfo: "Dodaj novo obvestilo",
    msgAnnouncesInfo: "Seznam mojih obvestil/objav",

    msgMyCertificates: "Moja potrdila",
    msgMyCertificatesInfo: "Seznam vseh mojih potrdil",

    msgDatenEnd: "Datum konca",
    msgText: "Tekst",
    msgWriteText: "Napiši svoje besedilo",

    msgTitle: "Naslov",

    msgTerms: "Sprejmite naše podatke <a href='https://ambitcluster.org/en/privacy-policy'>pravilnik o zasebnosti.</a>",
    msgCopyright: "Copyright&copy;2025 FLIER. Vse pravice pridržane",

    msgProyectOwner: "PROJEKT O",
    msgFooterContact: "KONTAKTIRAJTE NAS",
    msgFooterNews: "NAŠE NOVICE",
    msgFooterLegal: "Pravno obvestilo",
    msgFooterPrivacy: "Zasebnsot",
    msgFooterCookies: "Pravilnik o piškotkih",
    msgFooterCondic: "Splošni pogoji storitve",
    msgFooterCalidad: "Política de calidad",
    msgFooterEu: "Projekt \"FLIER\" je sofinanciran s strani programa Erasmus+ Evropske unije. Izražena stališča in mnenja so le avtorjevi in ne odražajo njujo stališče Evropske unije, ki ne mora odgovarjati zanje.",
    msgFooterGr: "Pogodba o dodelitvi sredstev: 2023-1-ES01-KA220-VET-000157705",
    msgCookies: "Esta Web utiliza cookies de terceros de publicidad comportamental propiedad de Google, persistentes durante 2 años, para mejorar nuestros servicios y mostrarle publicidad relacionada con sus preferencias mediante el análisis de sus hábitos de navegación. Si continúa navegando consideramos que está de acuerdo con su uso. Podrá revocar el consentimiento y obtener más información consultando nuestra Política de cookies.",
    msgFooterLinkedIn: 'LINKEDIN GROUP',

    msgSendSuccess: "Operacija uspešna",

    errorOblData: "Izpolnite vsa zahtevana polja",
    errorLogin: "e-pošta/geslo je napačno",
    errorSend: "Napaka pri delovanju, preverite svoje podatke",
    errorEmailFormat: "Napaka oblike pošte",
    errorRecovery: "Napaka obnovitvenega gesla, preverite navedeno kodo",
    errorTerms: "Sprejeti morate določila in pogoje",

    msgNotPass: "Tega testa noste opravili, prosim ponovno preberite lekcijo in poskusite znova.",
    msgCongratulations: "Čestitamo !! Opravili ste ta preizkus. Svoj certifikat lahko najdete  v razdelku profila.",

    /* TIPI PROFILOV */
    msgStudent: "Študent",
    msgVetProvider: "Učitelj - VET",
    msgHightEducation: "Provesor - Visokošolsko izobraževanje",
    msgCompany: "Podjetje",
    msgCompanyWorker: "Delavec",
    msgCompanyManager: "Manager podjetja",
    msgOther: "Drugi",

    /* SPOL */
    msgFemale: "Ženska",
    msgMale: "Moški",
    msgLetme: "Naj vtipkam…",    
    msgNotSay: "Raje ne povem",
       

    /* Države */
    msgAfghanistan: "afganistan",
    msgAlbania: "Albanija",
    msgAlgeria: "Alžirija",
    msgAmericanSamoa: "Ameriška Samoa",
    msgAndorra: "Andora",
    msgAngola: "Angola",
    msgAnguilla: "Angvila",
    msgAntarctica: "Antarktika",
    msgAntiguaandBarbuda: "Antigva in Barbuda",
    msgArgentina: "Argentina",
    msgArmenia: "Armenija",
    msgAruba: "Aruba",
    msgAustralia: "Australija",
    msgAustria: "Austrija",
    msgAzerbaijan: "Azerbajdžan",
    msgBahamas: "Bahami",
    msgBahrain: "Bahrajn",
    msgBangladesh: "Bangladeš",
    msgBarbados: "Barbados",
    msgBelarus: "Belorusija",
    msgBelgium: "Belgija",
    msgBelize: "Belize",
    msgBenin: "Benin",
    msgBermuda: "Bermuda",
    msgBhutan: "Bhtan",
    msgBolivia: "Bolivija",
    msgBosniaHerzegovina: "Bosna in Hercegovina",
    msgBotswana: "Botcvana",
    msgBouvetIsland: "Bouvetov otok",
    msgBrazil: "Brazilija",
    msgBritishIndian: "Britansko ozemlje v Indijskem ocenau",
    msgBrunei: "Brunej",
    msgBulgaria: "Bolgarija",
    msgBurkinaFaso: "Burkina Faso",
    msgBurundi: "Burundi",
    msgCambodia: "Kambodža",
    msgCameroon: "Kamerun",
    msgCanada: "Kanada",
    msgCapeVerde: "Zelenortski otoki",
    msgCaymanIslands: "Kajmanski otoki",
    msgCentralAfrican: "Srednjeafriška republika",
    msgChad: "Čad",
    msgChile: "Čile",
    msgChina: "Kitajska",
    msgChristmasIsland: "Božični otok",
    msgCocosIslands: "Kellingovi otoki",
    msgColombia: "Kolumbija",
    msgComoros: "Komori",
    msgCongo: "Kongo",
    msgRepublicCongo: "Demokratična republika Kongo",
    msgCookIslands: "Cookovi otoki",
    msgCostaRica: "Kostarika",
    msgIvoryCoast: "Slonokoščena obala",
    msgCroatia: "Hrvaška",
    msgCuba: "Kuba",
    msgCyprus: "Ciper",
    msgCzechRepublic: "Češka",
    msgDenmark: "Danska",
    msgDjibouti: "Džibutii",
    msgDominica: "Dominika",
    msgDominicanRepublic: "Dominikanska republika",
    msgEastTimor: "Vzhodni Timor",
    msgEcuador: "Ekvador",
    msgEgypt: "Egipt",
    msgEngland: "Anglija",
    msgElSalvador: "Salvador",
    msgEquatorialGuinea: "Ekvatorialna Gvineja",
    msgEritrea: "Eritreja",
    msgEstonia: "Estonija",
    msgEthiopia: "Etiopija",
    msgFalklandIslands: "Falklandski otoki",
    msgFaroeIslands: "Ferski otoki",
    msgFijiIslands: "Fidžijski otoki",
    msgFinland: "Finska",
    msgFrance: "Francija",
    msgFrenchGuiana: "FRancoska Gvajana",
    msgFrenchPolynesia: "Francoska polinezija",
    msgFrenchSouthern: "Francoska južna ozemlja",
    msgGabon: "Gabon",
    msgGambia: "Gambija",
    msgGeorgia: "Gruzija",
    msgGermany: "Nemčija",
    msgGhana: "Gana",
    msgGibraltar: "Gibraltar",
    msgGreece: "Grčija",
    msgGreenland: "Grenlandija",
    msgGrenada: "Grenada",
    msgGuadeloupe: "Gvadelup",
    msgGuam: "Guam",
    msgGuatemala: "Gvatemala",
    msgGuernsey: "Guernsey",
    msgGuinea: "Gvineja",
    msgGuineaBissau: "Guineja-Bissau",
    msgGuyana: "Gvajana",
    msgHaiti: "Haiti",
    msgHeardMcDonald: "Otok Heard in McDonaldovi otoki",
    msgHolySee: "Sveti sedež (Vatikan)",
    msgHonduras: "Honduras",
    msgHongKong: "Hong Kong",
    msgHungary: "Madžarska",
    msgIceland: "Irska",
    msgIndia: "Indija",
    msgIndonesia: "Indonezija",
    msgIran: "Iran",
    msgIraq: "Irak",
    msgIreland: "Irska",
    msgIsrael: "Izrael",
    msgIsleMan: "Otok Man",
    msgItaly: "Italija",
    msgJamaica: "Jamajka",
    msgJapan: "Japonska",
    msgJersey: "Džersi",
    msgJordan: "Jordanija",
    msgKazakhstan: "Kazahstan",
    msgKenya: "Kenija",
    msgKiribati: "Kiribati",
    msgKuwait: "Kuvajt",
    msgKyrgyzstan: "Kirgizistan",
    msgLaos: "Laos",
    msgLatvia: "Latvija",
    msgLebanon: "Libanon",
    msgLesotho: "Lesoto",
    msgLiberia: "Liberija",
    msgLibyanJamahiriya: "Libijska Arabska Džamahirija",
    msgLiechtenstein: "Lihtenštajn",
    msgLithuania: "Litva",
    msgLuxembourg: "Luksenburg",
    msgMacao: "Makao",
    msgNorthMacedonia: "Severna Makedonija",
    msgMadagascar: "Madagasker",
    msgMalawi: "Malavi",
    msgMalaysia: "Malezija",
    msgMaldives: "Maldivi",
    msgMali: "Mali",
    msgMalta: "Malta",
    msgMarshallIslands: "Marshallovi otoki",
    msgMartinique: "Martinik",
    msgMauritania: "Mavretanija",
    msgMauritius: "Mavricij",
    msgMayotte: "Mayotte",
    msgMexico: "Mehika",
    msgMicronesia: "Mikronezija, Zvezne države",
    msgMoldova: "Moldavija",
    msgMonaco: "Monako",
    msgMongolia: "Mongolija",
    msgMontserrat: "Montserrat",
    msgMontenegro: "Črna gora",
    msgMorocco: "Maroko",
    msgMozambique: "Mozambik",
    msgMyanmar: "Mjanmar",
    msgNamibia: "Namibija",
    msgNauru: "Nauru",
    msgNepal: "Nepal",
    msgNetherlands: "Nizizemska",
    msgNetherlandsAntilles: "Nizozemski Antili",
    msgNewCaledonia: "Nova Kaledonija",
    msgNewZealand: "Nova Zelandija",
    msgNicaragua: "Nikaragva",
    msgNiger: "Niger",
    msgNigeria: "Nigerija",
    msgNiue: "Niue",
    msgNorfolkIsland: "Otok Norfolk",
    msgNorthKorea: "Severna Koreja",
    msgNorthernIreland: "Northern Ireland",
    msgNorthernMariana: "Severni Marianski otoki",
    msgNorway: "Norveška",
    msgOman: "Oman",
    msgPakistan: "Pakistan",
    msgPalau: "Palau",
    msgPalestine: "Palestina",
    msgPanama: "Panama",
    msgPapua: "Papua Nova Gvineja",
    msgParaguay: "Paragvaj",
    msgPeru: "Peru",
    msgPhilippines: "Filipini",
    msgPitcairn: "Pitcairn",
    msgPoland: "Poljska",
    msgPortugal: "Portugalska",
    msgPuertoRico: "Portoriko",
    msgQatar: "Katar",
    msgReunion: "Pomovna združitev",
    msgRomania: "Romunija",
    msgRussianFederation: "Ruska federacija",
    msgRwanda: "Ruanda",
    msgSaintHelena: "Sveta Helena",
    msgSaintKitts: "Sveti Kitts in Nevis",
    msgSaintLucia: "Sveta Lucija",
    msgSaintPierre: "Sveti Pierre in  Miquelon",
    msgSaintVincent: "Sveti Vincent in Grenadini",
    msgSamoa: "Samoa",
    msgSanMarino: "San Marino",
    msgSaoTome: "Sao Tome in Principe",
    msgSaudiArabia: "Saudova Arabija",
    msgScotland: "Škodska",
    msgSenegal: "Senegal",
    msgSerbia: "Srbija",
    msgSeychelles: "Sejšeli",
    msgSierraLeone: "Sierra Leone",
    msgSingapore: "Singapur",
    msgSlovakia: "Slovaška",
    msgSlovenia: "Slovenija",
    msgSolomonIslands: "Salomonovi otoki",
    msgSomalia: "Somalija",
    msgSouthAfrica: "Južna Afrika",
    msgSouthSandwich: "Južna Georgia in Južni Sandwich otoki",
    msgSouthKorea: "Južna koreja",
    msgSouthSudan: "Južni Sudan",
    msgSpain: "Spanija",
    msgSriLanka: "ŠriLanka",
    msgSudan: "Sudan",
    msgSuriname: "Surinam",
    msgSvalbardJan: "Svalbard in Jan Mayen",
    msgSwaziland: "Svazi",
    msgSweden: "Švedska",
    msgSwitzerland: "Švica",
    msgSyria: "Sirija",
    msgTajikistan: "Tadžikistan",
    msgTanzania: "Tanzanija",
    msgThailand: "Tajska",
    msgTimorLeste: "Vzhodni Timor",
    msgTogo: "Togo",
    msgTokelau: "Tokelau",
    msgTonga: "Tonga",
    msgTrinidadTobago: "Trinidad in Tobago",
    msgTunisia: "Tunizija",
    msgTurkey: "Turčija",
    msgTurkmenistan: "Turkmenistan",
    msgTurksCaicos: "Otoki Turks in Caicos",
    msgTuvalu: "Tuvalu",
    msgUganda: "Uganda",
    msgUkraine: "Ukrajina",
    msgUnitedArabEmirates: "Združeni arabski emirati",
    msgUnitedKingdom: "Združeno kraljestvo",
    msgUnitedStates: "Združene države",
    msgUnitedStatesMinor: "Manj oddaljeni otoki Združenih držav Amerike",
    msgUruguay: "Uruguaj",
    msgUzbekistan: "Uzbekistan",
    msgVanuatu: "Vanuatu",
    msgVenezuela: "Venezuela",
    msgVietnam: "Vietnam",
    msgVirginIslandsBritish: "Deviški otoki, Britanski",
    msgVirginIslandsUS: "Deviški otoki, ZDA",
    msgWales: "Wales",
    msgWallisFutuna: "Wallis in Futuna",
    msgWesternSahara: "Zahodna Sahara",
    msgYemen: "Jemen",
    msgZambia: "Zambija",
    msgZimbabwe: "Zimbabve",
}

export default si;